export default {
  title: 'Política de Privacidad',
  lastUpdated: 'Última actualización: 27 de noviembre de 2025',
  section1: {
    title: '1. Introducción',
    content: 'Bienvenido a UmiGo. Respetamos su privacidad y nos comprometemos a proteger sus datos personales. Esta política de privacidad le informará sobre cómo cuidamos sus datos personales cuando utiliza nuestra aplicación móvil y sitio web, y le informará sobre sus derechos de privacidad y cómo la ley lo protege.'
  },
  section2: {
    title: '2. Información que Recopilamos',
    intro: 'Recopilamos y procesamos los siguientes tipos de información:',
    items: [
      '<strong>Información de la Cuenta:</strong> Nombre de usuario, dirección de correo electrónico, número de teléfono, fecha de nacimiento, género y foto de perfil',
      '<strong>Datos del Perfil:</strong> Biografía, intereses, preferencias y configuraciones que configure',
      '<strong>Contenido:</strong> Mensajes, fotos, videos, grabaciones de voz y otro contenido que cree o comparta',
      '<strong>Datos de Uso:</strong> Información sobre cómo utiliza nuestros servicios, incluidas las funciones accedidas, el tiempo dedicado y las interacciones',
      '<strong>Información del Dispositivo:</strong> Tipo de dispositivo, sistema operativo, identificadores únicos del dispositivo, información de red móvil',
      '<strong>Datos de Ubicación:</strong> Ubicación aproximada basada en la dirección IP o ubicación precisa si otorga permiso',
      '<strong>Información de Pago:</strong> Detalles de la tarjeta de pago e historial de transacciones para compras dentro de la aplicación',
      '<strong>Comunicaciones:</strong> Interacciones de atención al cliente y comentarios que proporcione'
    ]
  },
  section3: {
    title: '3. Cómo Usamos su Información',
    intro: 'Usamos su información para:',
    items: [
      'Proporcionar, mantener y mejorar nuestros servicios',
      'Crear y administrar su cuenta',
      'Habilitar la comunicación entre usuarios a través de funciones de mensajería, voz y video',
      'Personalizar su experiencia y proporcionar recomendaciones de contenido',
      'Procesar transacciones y enviar información relacionada',
      'Enviarle avisos técnicos, actualizaciones, alertas de seguridad y mensajes de soporte',
      'Responder a sus comentarios, preguntas y solicitudes de servicio al cliente',
      'Monitorear y analizar tendencias, uso y actividades',
      'Detectar, prevenir y abordar problemas técnicos, fraude y actividades ilegales',
      'Cumplir con obligaciones legales y hacer cumplir nuestros términos'
    ]
  },
  section4: {
    title: '4. Compartir y Divulgación de Información',
    intro: 'Podemos compartir su información en las siguientes circunstancias:',
    items: [
      '<strong>Con Otros Usuarios:</strong> Su información de perfil y el contenido que comparte son visibles para otros usuarios según su configuración de privacidad',
      '<strong>Proveedores de Servicios:</strong> Empresas de terceros que nos ayudan a operar nuestros servicios (alojamiento, análisis, procesamiento de pagos, atención al cliente)',
      '<strong>Transferencias Comerciales:</strong> En relación con cualquier fusión, venta de activos de la empresa, financiamiento o adquisición',
      '<strong>Requisitos Legales:</strong> Cuando lo exija la ley o para proteger derechos, propiedad o seguridad',
      '<strong>Con su Consentimiento:</strong> Cuando acepta explícitamente compartir información con terceros'
    ],
    note: 'No vendemos su información personal a terceros con fines de marketing.'
  },
  section5: {
    title: '5. Seguridad de Datos',
    intro: 'Implementamos medidas técnicas y organizativas apropiadas para proteger sus datos personales contra el acceso no autorizado, alteración, divulgación o destrucción. Esto incluye:',
    items: [
      'Cifrado de extremo a extremo para mensajes privados',
      'Transmisión segura de datos mediante protocolos SSL/TLS',
      'Evaluaciones y actualizaciones de seguridad regulares',
      'Controles de acceso y mecanismos de autenticación',
      'Capacitación de empleados sobre prácticas de protección de datos'
    ]
  },
  section6: {
    title: '6. Retención de Datos',
    content: 'Conservamos sus datos personales solo durante el tiempo necesario para cumplir con los propósitos descritos en esta política de privacidad, a menos que la ley requiera un período de retención más largo. Cuando elimine su cuenta, eliminaremos o anonimizaremos sus datos personales dentro de los 90 días, excepto cuando necesitemos conservarlos para cumplimiento legal o propósitos comerciales legítimos.'
  },
  section7: {
    title: '7. Sus Derechos de Privacidad',
    intro: 'Dependiendo de su ubicación, puede tener los siguientes derechos:',
    items: [
      '<strong>Acceso:</strong> Solicitar acceso a sus datos personales',
      '<strong>Corrección:</strong> Solicitar la corrección de datos inexactos o incompletos',
      '<strong>Eliminación:</strong> Solicitar la eliminación de sus datos personales',
      '<strong>Portabilidad:</strong> Solicitar la transferencia de sus datos a otro servicio',
      '<strong>Objeción:</strong> Oponerse al procesamiento de sus datos personales',
      '<strong>Restricción:</strong> Solicitar la restricción del procesamiento',
      '<strong>Retirar Consentimiento:</strong> Retirar el consentimiento en cualquier momento cuando nos basemos en el consentimiento'
    ],
    note: 'Para ejercer estos derechos, contáctenos en privacy@umigo.cc'
  },
  section8: {
    title: '8. Privacidad de los Niños',
    content: 'UmiGo no está destinado a usuarios menores de 13 años (o 16 en ciertas jurisdicciones). No recopilamos intencionalmente información personal de niños. Si nos enteramos de que un niño nos ha proporcionado datos personales, tomaremos medidas para eliminar dicha información. Si cree que hemos recopilado información de un niño, contáctenos de inmediato.'
  },
  section9: {
    title: '9. Transferencias Internacionales de Datos',
    content: 'Su información puede ser transferida y procesada en países distintos a su país de residencia. Estos países pueden tener leyes de protección de datos diferentes. Nos aseguramos de que existan salvaguardas apropiadas para proteger sus datos personales de acuerdo con esta política de privacidad.'
  },
  section10: {
    title: '10. Cookies y Tecnologías de Seguimiento',
    content: 'Utilizamos cookies y tecnologías de seguimiento similares para recopilar y rastrear información sobre su uso de nuestros servicios. Puede controlar las cookies a través de la configuración de su navegador, pero deshabilitar las cookies puede afectar su capacidad para usar ciertas funciones.'
  },
  section11: {
    title: '11. Enlaces y Servicios de Terceros',
    content: 'Nuestros servicios pueden contener enlaces a sitios web o servicios de terceros. No somos responsables de las prácticas de privacidad de estos terceros. Le recomendamos que lea sus políticas de privacidad antes de proporcionar cualquier información.'
  },
  section12: {
    title: '12. Cambios a esta Política de Privacidad',
    content: 'Podemos actualizar esta política de privacidad de vez en cuando. Le notificaremos cualquier cambio publicando la nueva política de privacidad en esta página y actualizando la fecha de "Última actualización". El uso continuado de nuestros servicios después de los cambios constituye la aceptación de la política actualizada.'
  },
  section13: {
    title: '13. Contáctenos',
    intro: 'Si tiene alguna pregunta sobre esta política de privacidad o nuestras prácticas de privacidad, contáctenos:',
    email: '<strong>Correo electrónico:</strong> privacy@umigo.cc',
    phone: '<strong>Teléfono:</strong> WA: +52 8 132724843',
    address: '<strong>Dirección:</strong> Av. Paseo de la Reforma 222, Ciudad de México, CDMX 06600, México'
  },
  regional: {
    title: 'Información de Privacidad Regional',
    ccpa: {
      title: 'Para Residentes de California (CCPA)',
      intro: 'Los residentes de California tienen derechos adicionales bajo la Ley de Privacidad del Consumidor de California (CCPA):',
      items: [
        'Derecho a saber qué información personal se recopila, usa, comparte o vende',
        'Derecho a eliminar información personal',
        'Derecho a optar por no participar en la venta de información personal',
        'Derecho a no discriminación por ejercer los derechos de CCPA'
      ]
    },
    gdpr: {
      title: 'Para Usuarios Europeos (GDPR)',
      content: 'Si se encuentra en el Espacio Económico Europeo (EEE), tiene derechos bajo el Reglamento General de Protección de Datos (GDPR), incluido el derecho a acceder, rectificar, borrar, restringir el procesamiento, portabilidad de datos y oponerse al procesamiento de sus datos personales.'
    }
  }
};
